const state = {
    button_width: [],
};

const getters = {
    getButtonWidth: state => state.button_width,
};

// const actions = {
//     async fetchUsers({ commit }) {
//         const response = await axios.get(
//             'https://jsonplaceholder.typicode.com/users'
//         )
//
//         commit('setUsers', response.data)
//     },
// }

const mutations = {
    setButtonWidth: (state, button_width) =>
        (state.button_width = button_width),
};

export default {
    state,
    getters,
    // actions,
    mutations,
};
